export enum AuthReducerAction {
  Init = 'init',
  SignIn = 'signIn',
  SignOut = 'signOut',
  UpdateAvatar = 'updateAvatar',
  UpdateUserInfo = 'updateUserInfo',
  UpdateAppSettings = 'updateAppSettings',
  UpdateAuthToken = 'updateAuthToken'
}
